import { useState, useEffect } from 'react';
import { getTransactions } from '../../../utils/requestApi';
import { useWeb3React } from '@web3-react/core';
import { chakra, Flex, Box, Text, Link, TableCaption, Table } from '@chakra-ui/react';
import { ReactComponent as ReceiveImg } from '../../../assets/images/receive.svg';
import { ReactComponent as SendImg } from '../../../assets/images/send.svg';
import { truncateAddress, getTransactionExplorerUrl } from '../../../utils/helper';
import { CopyIcon, ExternalLinkIcon } from '@chakra-ui/icons';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useParams } from 'react-router-dom';
import Pagination from '../../../ui-kit/Pagination';

const pageLimit = 10;

const Contributions = ({ address }) => {
  const { id } = useParams();
  const { chainId, account } = useWeb3React();

  const [contributionsInfo, setContributionsInfo] = useState({ contributions: null, totalContributions: 0 });
  const [pagination, setPagination] = useState({
    currentContributions: null,
    currentPage: 1,
    totalPages: null,
    totalCount: null,
  });

  const [, setIsCopy] = useState({
    value: '',
    copied: false
  });

  const getAccountTransactions = async () => {
    const response = await getTransactions({ id, page: pagination.currentPage });
    const { transactions, total_count } = response.data;
    setContributionsInfo({ contributions: transactions, totalContributions: parseInt(total_count) });
  };

  useEffect(() => {
    // if (account && chainId) {
    getAccountTransactions();
    // }
  }, [account, chainId]);

  const onPageChanged = async (data) => {
    const { currentPage, totalPages } = data;
    const offset = (currentPage - 1) * pageLimit;
    const response = await getTransactions({ id, page: currentPage });
    const { transactions, page_count, total_count } = response.data;
    setContributionsInfo({ contributions: transactions, totalContributions: parseInt(total_count) });
    const currentContributions = transactions.slice(offset, offset + pageLimit);

    setPagination({
      currentContributions,
      currentPage,
      totalPages,
      totalCount: parseInt(total_count),
    });
  };

  return (
    <div data-category="contributions" hidden>
      <Table className="table" >
        <thead className="table__head">
          <tr className="table__row">
            <td className="table__column">Transaction Type</td>
            <td className="table__column">Value</td>
            <td className="table__column">Address</td>
            <td className="table__column">Transaction Hash</td>
          </tr>
        </thead>
        <tbody className="table__body">
          {contributionsInfo.contributions &&
            contributionsInfo.contributions.map((item, index) => {
              const isIncomingTransaction = item.tx_type === 'incoming';
              return (
                <tr className="table__row" key={index}>
                  <td className="table__column">
                    <Flex flexFlow={'row'} alignItems="center" gap={'2'}>
                      {isIncomingTransaction ? 'Receive' : 'Send'}
                      {isIncomingTransaction ? <ReceiveImg /> : <SendImg />}
                    </Flex>
                  </td>
                  <td className="table__column"> ${item.value.toFixed(2)}</td>
                  <td className="table__column">
                    <Box pb={1} fontWeight="bold">
                      {isIncomingTransaction ? 'From' : 'To'}
                    </Box>
                    <CopyToClipboard text={item.address} onCopy={() => setIsCopy({ copied: true })}>
                      <chakra.span cursor={'pointer'}>{truncateAddress(item.address)}</chakra.span>
                    </CopyToClipboard>
                  </td>
                  <td className="table__column">
                    <Flex flexFlow={'row'} gap={2}>
                      <Text>{truncateAddress(item.tx_hash)}</Text>
                      <CopyToClipboard text={item.tx_hash} onCopy={() => setIsCopy({ copied: true })}>
                        <span>
                          <CopyIcon cursor={'pointer'} />
                        </span>
                      </CopyToClipboard>
                      <Link href={`${getTransactionExplorerUrl(chainId)}/${item.tx_hash}`} isExternal>
                        <ExternalLinkIcon />{' '}
                      </Link>
                    </Flex>
                  </td>
                </tr>
              );
            })}
        </tbody>
        {contributionsInfo.totalContributions > pageLimit && (
          <TableCaption height="55px" width="100%" paddingInlineEnd={0}>
            <Pagination
              totalRecords={contributionsInfo.totalContributions}
              pageLimit={pageLimit}
              pageNeighbours={0}
              onPageChanged={onPageChanged}
            />
          </TableCaption>
        )}

        
      </Table>
     
      {contributionsInfo?.contributions && contributionsInfo?.contributions.length == 0 && <div className='no-data_container'>
      <svg width="142" height="142" viewBox="0 0 142 142" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="71" cy="71" r="71" fill="rgba(53, 156, 251, 1)" fillOpacity="1"/>
            <path d="M40 42.5H57L63 47.5H98.5C102.918 47.5 106.5 51.0817 106.5 55.5V56.5V65.5H56L43 100H40C36.6863 100 34 97.3137 34 94V48.5C34 45.1863 36.6863 42.5 40 42.5Z" fillOpacity="0" fill="white"/>
            <path d="M106.632 65.2V53.4588C106.632 50.1451 103.946 47.4588 100.632 47.4588H62.6437L59.5311 44.3446C58.0307 42.8434 55.9953 42 53.8728 42H40C36.6863 42 34 44.6863 34 48V93C34 96.866 37.134 100 41 100H42.8659M106.632 65.2H121.6C122.286 65.2 122.768 65.8753 122.546 66.5244L111.992 97.2976C111.438 98.9142 109.917 100 108.208 100H42.8659M106.632 65.2H58.6026C56.9319 65.2 55.4371 66.2385 54.8541 67.8042L42.8659 100" stroke="#ffffff" strokeWidth="2"/>
          </svg>
          No data
      </div>} 
    </div>
  );
};

export default Contributions;
